var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.id && _vm.valid)?[_vm._v(" 読み込み中です。。。 ")]:(_vm.checkAgain)?[_vm._v(" 読み込み中にエラーが発生しました。URLを確認してもう一度お試し下さい。 ")]:[_vm._v(" 不正なURLです。 ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }